import { css } from "@emotion/css";
import { SectionHeader } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { MachineConnectionStatus } from "@octopusdeploy/octopus-server-client";
import { noOp } from "@octopusdeploy/utilities";
import TaskLogLines from "~/components/TaskLogLines/TaskLogLines";
interface CommunicationLogsProps {
    connectionStatus: MachineConnectionStatus;
}
const styles = {
    commsLogsSection: css({
        padding: `${space[8]} ${space[16]}`,
    }),
};
export function CommunicationLogs({ connectionStatus }: CommunicationLogsProps) {
    if (connectionStatus.Logs?.length === 0) {
        return null;
    }
    return (<>
            <SectionHeader title="Recent Communication Logs"/>
            <section className={styles.commsLogsSection}>
                <TaskLogLines lines={connectionStatus.Logs} showTimestamps={true} onFetchRange={noOp} isFetchDisabled={true}/>
            </section>
        </>);
}
